import React from 'react';
import PropTypes from 'prop-types';
import ToggleInput, {ToggleInputProps} from '@nib-components/toggle-input';

export interface CheckboxProps extends ToggleInputProps {
  checked?: boolean;
}

const Checkbox: React.FC<CheckboxProps> = (props): JSX.Element => {
  return <ToggleInput {...props} selected={props.checked} type="checkbox" />;
};

Checkbox.displayName = 'Checkbox';

Checkbox.propTypes = {
  // 'id' and 'name' come from the FormControl wrapping this component
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  inline: PropTypes.bool,
  disabled: PropTypes.bool
};

Checkbox.defaultProps = {
  checked: false
};

export default Checkbox;
